import Vue from 'vue';
import VueSession from 'vue-session';
import axios from 'axios';
import VueAxios from 'vue-axios';
import event from 'vue-event-manager';
import excel from 'vue-excel-export';
import Tawk from './plugins/Tawk';
import store from './store';
import App from './App.vue';

import router from './routes/router';
import vuetify from './plugins/vuetify';
import rules from './plugins/rules';
import './plugins/vMask';
import './misc';
import '@babel/polyfill';

// Custom Css
import '@/assets/scss/main.scss';

Vue.use(Tawk, {});
Vue.use(excel);
Vue.use(event);
Vue.use(VueAxios, axios);
Vue.use(VueSession);
Vue.use(rules);


Vue.config.devtools = false;
Vue.config.productionTip = false;

const { token } = store.state;
if (token) {
  Vue.axios.defaults.headers.common.Authorization = `Bearer ${token}`;
}
Vue.axios.defaults.baseURL = store.getters.apiEndpoint;
Vue.axios.defaults.timeout = 500000;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
